module.exports = __webpack_public_path__ + "img/subscription.9ceb05f8.png";